/**
 * 値が定義されているかどうか
 * @param value
 */
export const isDefined = function (value: any) {
  return typeof value !== 'undefined';
};

export default isDefined;
